export class ClientFilter {
    id: number = 0;
    cnpj: string = "";
    corporateName: string = "";
}
